import { SB } from '@play-co/replicant';

export const conversionSaleSchema = {
  conversionSale: SB.object({
    // List of events started by the user
    events: SB.map(
      SB.object({
        // Timestamp of when event started for the user
        startedAt: SB.number(),
        // Number of purchases made for the event
        purchases: SB.number(),
        // Timestamp of the last time user has purchased a product for the event
        lastPurchasedAt: SB.number(),
        // Timestamp of the last time user has been seen the conversion sale event
        lastSeenAt: SB.number(),
      }),
    ).optional(),
  }).optional(),
};
